import { getNumberOfNights } from '../util/dataLayer';
import type { GTMItemData, GTMItemsReturnTypeCategories } from './GTM.types';

const INSTANT_BOOKING_FEATURE_VALUE = 'instantBooking';
const UNKNOWN_COUNTRY_VALUE = 'unknown country';
const UNKNOWN_REGION_VALUE = 'unknown region';
const UNKNOWN_DEPARTMENT_VALUE = 'unknown department';
const UNKNOWN_PLACE_VALUE = 'unknown place';

export function calculateNumberOfNights(houseData: {
    arrivalDate: string;
    departureDate: string;
}): number | null {
    const arrivalDate = new Date(houseData.arrivalDate);
    const departureDate = new Date(houseData.departureDate);

    if (Number.isNaN(arrivalDate.getTime()) || Number.isNaN(departureDate.getTime())) {
        return null;
    }

    return getNumberOfNights(arrivalDate, departureDate);
}

export function hasInstantBooking(features: string[]): boolean {
    return features.includes(INSTANT_BOOKING_FEATURE_VALUE);
}

export function calculatePricePerNight(price: number, numberOfNights: number): number {
    if (numberOfNights === 0) {
        return price;
    }

    return Number((price / numberOfNights).toFixed(2));
}

export function calculateValue(pricePerNight: number, numberOfNights: number): number {
    return Number((pricePerNight * numberOfNights).toFixed(2));
}

export function useFallbackForEmptyCategories({
    country,
    region,
    department,
    place
}: Partial<GTMItemData>): GTMItemsReturnTypeCategories {
    const fallbackOrUndefined = (
        value: string | undefined,
        fallback: string
    ): string | undefined => {
        if (value === undefined) {
            return undefined;
        }

        if (value.trim() !== '') {
            return value;
        }

        return fallback;
    };

    return {
        item_category: fallbackOrUndefined(country, UNKNOWN_COUNTRY_VALUE),
        item_category2: fallbackOrUndefined(region, UNKNOWN_REGION_VALUE),
        item_category3: fallbackOrUndefined(department, UNKNOWN_DEPARTMENT_VALUE),
        item_category4: fallbackOrUndefined(place, UNKNOWN_PLACE_VALUE)
    };
}
